var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
export function handleAskLubavApiCall(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var url, accessToken, res, errorData, reader, decoder, text, _c, done, value, chunk, error_1;
        var _d, _e;
        var url_key = _b.url_key, apiUrl = _b.apiUrl, inputData = _b.inputData, userId = _b.userId, getToken = _b.getToken, askLubavResponseAccumulator = _b.askLubavResponseAccumulator;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    url = "".concat(apiUrl, "/api/generate/").concat(url_key);
                    accessToken = userId && getToken ? getToken() : undefined;
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 8, , 9]);
                    return [4, fetch(url, {
                            method: 'POST',
                            headers: __assign({ 'Content-Type': 'application/json' }, (accessToken ? { Authorization: "Bearer ".concat(accessToken) } : {})),
                            body: JSON.stringify(inputData),
                        })];
                case 2:
                    res = _f.sent();
                    if (!!res.ok) return [3, 4];
                    return [4, res.json()];
                case 3:
                    errorData = _f.sent();
                    return [2, {
                            response: errorData,
                            isError: true,
                            loadingButton: url_key,
                            errorCode: (_d = errorData.detail) === null || _d === void 0 ? void 0 : _d.code,
                        }];
                case 4:
                    reader = (_e = res.body) === null || _e === void 0 ? void 0 : _e.getReader();
                    decoder = new TextDecoder();
                    text = '';
                    _f.label = 5;
                case 5:
                    if (!reader) return [3, 7];
                    return [4, reader.read()];
                case 6:
                    _c = _f.sent(), done = _c.done, value = _c.value;
                    if (done)
                        return [3, 7];
                    chunk = decoder.decode(value);
                    if (askLubavResponseAccumulator) {
                        askLubavResponseAccumulator(chunk);
                    }
                    text += chunk;
                    return [3, 5];
                case 7: return [2, {
                        response: text,
                        isError: false,
                        loadingButton: url_key,
                    }];
                case 8:
                    error_1 = _f.sent();
                    console.error({ error: error_1 });
                    return [2, {
                            response: undefined,
                            isError: true,
                            loadingButton: url_key,
                        }];
                case 9: return [2];
            }
        });
    });
}
export var attemptToFixJson = function (input, expectedStructure) {
    var fixedInput = input.trim();
    if (!fixedInput.startsWith('{')) {
        return JSON.stringify(expectedStructure);
    }
    if (!fixedInput.endsWith('}')) {
        var keys = Object.keys(expectedStructure);
        for (var i = keys.length - 1; i >= 0; i--) {
            var key = keys[i];
            var expectedValue = expectedStructure[key];
            var keyPattern = "\"".concat(key, "\":");
            if (fixedInput.includes(keyPattern)) {
                var keyStart = fixedInput.lastIndexOf(keyPattern);
                var lastQuote = fixedInput.lastIndexOf('"');
                var lastOpenBracket = fixedInput.lastIndexOf('[');
                var lastCloseBracket = fixedInput.lastIndexOf(']');
                if (Array.isArray(expectedValue)) {
                    if (lastQuote > keyStart && lastQuote > lastOpenBracket) {
                        fixedInput += '"]}';
                    }
                    else if (lastCloseBracket > lastOpenBracket) {
                        fixedInput += ']}';
                    }
                    else if (lastOpenBracket > lastQuote) {
                        fixedInput += ']}';
                    }
                    else {
                        fixedInput += ']';
                        for (var j = i - 1; j >= 0; j--) {
                            fixedInput += ",\"".concat(keys[j], "\":").concat(JSON.stringify(expectedStructure[keys[j]]));
                        }
                        fixedInput += '}';
                    }
                }
                else {
                    fixedInput += '"';
                    for (var j = i - 1; j >= 0; j--) {
                        fixedInput += ",\"".concat(keys[j], "\":").concat(JSON.stringify(expectedStructure[keys[j]]));
                    }
                    fixedInput += '}';
                }
                break;
            }
        }
    }
    try {
        var parsed = JSON.parse(fixedInput);
        return JSON.stringify(__assign(__assign({}, expectedStructure), parsed));
    }
    catch (_a) {
        return undefined;
    }
};
